import React from 'react';
import textSizeUtils from './TextSizeUtils';
import locales from '../../locales/LocalesManager';
import properties from '../../constants/Properties';
import platformDetection from './PlatformDetection';

const hoverManager = {
    toolTip: undefined,
    isRecording: false,

    removeOldTooltip() {
        if (this.toolTip && this.toolTip.parentNode)
            this.toolTip.parentNode.removeChild(this.toolTip);
    },
    getText(type) {
        var text = '';
        var useTranslation = true;

        switch(type) {
            case 'addSlide': {
                text = locales.getCaption('addSlide', 'hover');
                break;
            }
            case 'preview': {
                text = locales.getCaption('preview', 'hover');
                break;
            }
            case 'undo': {
                text = locales.getCaption('undo', 'hover');
                break;
            }
            case 'redo': {
                text = locales.getCaption('redo', 'hover');
                break;
            }
            case 'playSlide': {
                text = locales.getCaption('playSlide', 'hover');
                break;
            }
            case 'stop': {
                text = locales.getCaption('stop', 'hover');
                break;
            }
            case 'slideDuration': {
                text = locales.getCaption('slideDuration', 'hover');
                break;
            }
            case 'resizeAccordion': {
                text = locales.getCaption('resizeAccordion', 'hover');
                break;
            }
            case 'expandedListView': {
                text = locales.getCaption('expandedListView', 'hover');
                break;
            }
            case 'collapsedListView': {
                text = locales.getCaption('collapsedListView', 'hover');
                break;
            }
            case 'playSoundItem': {
                text = locales.getCaption('playSoundItem', 'hover');
                break;
            }
            case 'saveButton': {
                text = locales.getCaption('saveButton', 'hover');
                break;
            }
            case 'helpButton': {
                text = locales.getCaption('helpButton', 'hover');
                break;
            }
            case 'searchButton': {
                text = locales.getCaption('searchButton', 'hover');
                break;
            }
            case 'closeSearchButton': {
                text = locales.getCaption('closeSearchButton', 'hover');
                break;
            }
            case 'uploadButton': {
                text = locales.getCaption('UploadHover', 'myFiles');
                break;
            }
            case 'editShape': {
                text = locales.getCaption('editShape', 'hover');
                break;
            }
            case 'editSlide': {
                text = locales.getCaption('editSlide', 'hover');
                break;
            }
            case 'deleteSound': {
                text = locales.getCaption('deleteSound', 'hover');
                break;
            }
            case 'volumeSound': {
                text = locales.getCaption('volumeSound', 'hover');
                break;
            }
            case 'playSound': {
                text = locales.getCaption('playSound', 'hover');
                break;
            }

            // Preview/Player mode
            case 'firstSlide': {
                text = locales.getCaption('firstSlide', 'hover');
                break;
            }
            case 'previousSlide': {
                text = locales.getCaption('previousSlide', 'hover');
                break;
            }
            case 'previewModePlayCartoon': {
                text = locales.getCaption('previewModePlayCartoon', 'hover');
                break;
            }
            case 'previewModePauseCartoon': {
                text = locales.getCaption('previewModePauseCartoon', 'hover');
                break;
            }
            case 'nextSlide': {
                text = locales.getCaption('nextSlide', 'hover');
                break;
            }
            case 'lastSlide': {
                text = locales.getCaption('lastSlide', 'hover');
                break;
            }
            case 'exitPreview': {
                text = locales.getCaption('exitPreview', 'hover');
                break;
            }

            case 'normalScreen': {
                text = locales.getCaption('normalScreen', 'hover');
                break;
            }

            case 'fullScreen': {
                text = locales.getCaption('fullScreen', 'hover');
                break;
            }

            // Video Editor
            case 'playVideo': {
                text = locales.getCaption('playVideo', 'hover');
                break;
            }
            case 'cancelVideo': {
                text = locales.getCaption('cancelVideo', 'hover');
                break;
            }
            case 'okVideo': {
                text = locales.getCaption('okVideo', 'hover');
                break;
            }
            case 'videoLeftTrim': {
                text = locales.getCaption('videoLeftTrim', 'hover');
                break;
            }
            case 'videoRightTrim': {
                text = locales.getCaption('videoRightTrim', 'hover');
                break;
            }
            case 'videoMinVolume': {
                text = locales.getCaption('videoMinVolume', 'hover');
                break;
            }
            case 'videoMaxVolume': {
                text = locales.getCaption('videoMaxVolume', 'hover');
                break;
            }

            // Audio Editor
            case 'zoomMinus': {
                text = locales.getCaption('zoomMinus', 'hover');
                break;
            }
            case 'zoomPlus': {
                text = locales.getCaption('zoomPlus', 'hover');
                break;
            }
            case 'showRightMenu': {
                text = locales.getCaption('showRightMenu', 'hover');
                break;
            }
            case 'hideRightMenu': {
                text = locales.getCaption('hideRightMenu', 'hover');
                break;
            }
            case 'deleteAudioItem': {
                text = locales.getCaption('deleteAudioItem', 'hover');
                break;
            }
            case 'splitAudio': {
                text = locales.getCaption('splitAudio', 'hover');
                break;
            }
            case 'addControlPoint': {
                text = locales.getCaption('addControlPoint', 'hover');
                break;
            }
            case 'playCartoon': {
                text = locales.getCaption('playCartoon', 'hover');
                break;
            }
            case 'goToStart': {
                text = locales.getCaption('goToStart', 'hover');
                break;
            }
            case 'goToEnd': {
                text = locales.getCaption('goToEnd', 'hover');
                break;
            }
            case 'trackVolume': {
                text = locales.getCaption('trackVolume', 'hover');
                break;
            }
            case 'audioLeftTrim': {
                text = locales.getCaption('audioLeftTrim', 'hover');
                break;
            }
            case 'audioRightTrim': {
                text = locales.getCaption('audioRightTrim', 'hover');
                break;
            }
            case 'slideTrim': {
                text = locales.getCaption('slideTrim', 'hover');
                break;
            }
            case 'audioVolumePoint': {
                text = locales.getCaption('audioVolumePoint', 'hover');
                break;
            }
            case 'trackSettings': {
                text = locales.getCaption('trackSettings', 'hover');
                break;
            }
            case 'startAudio': {
                text = locales.getCaption('startAudio', 'hover');
                break;
            }
            case 'backAudio': {
                text = locales.getCaption('backAudio', 'hover');
                break;
            }
            case 'nextAudio': {
                text = locales.getCaption('nextAudio', 'hover');
                break;
            }
            case 'endAudio': {
                text = locales.getCaption('endAudio', 'hover');
                break;
            }
            case 'changeVolume': {
                text = locales.getCaption('changeVolume', 'hover');
                break;
            }

            // old tooltips
            case 'SplitClipHover': {
                text = locales.getCaption('SplitClipHover', 'other');
                break;
            }
            case 'MySoundsTitle': {
                text = locales.getCaption('MySoundsTitle', 'music');
                break;
            }

            // left main menu
            case 'mainMenuText': {
                text = locales.getCaption('mainMenuText', 'hover');
                break;
            }
            case 'mainMenuDrawing': {
                text = locales.getCaption('mainMenuDrawing', 'hover');
                break;
            }
            case 'mainMenuShapes': {
                text = locales.getCaption('mainMenuShapes', 'hover');
                break;
            }
            case 'mainMenuEffects': {
                text = locales.getCaption('mainMenuEffects', 'hover');
                break;
            }
            case 'mainMenuFrames': {
                text = locales.getCaption('mainMenuFrames', 'hover');
                break;
            }
            case 'mainMenuMedia': {
                text = locales.getCaption('mainMenuMedia', 'hover');
                break;
            }

            /********************** Text Editor tool *********************/

            case 'textBox': {
                // text = 'Tekstboks uten ramme';
                text = locales.getCaption('TextBoxSimpleAriaLabel', 'other');
                break;
            }
            case 'textBoxSimple': {
                // text = 'Tekstboks med ramme';
                text = locales.getCaption('TextBoxAriaLabel', 'other');
                break;
            }
            case 'speechBubble': {
                // text = 'Snakkeboble';
                text = locales.getCaption('SpeechAriaLabel', 'other');
                break;
            }
            case 'thoughtBubble': {
                // text = 'Tankeboble';
                text = locales.getCaption('ThoughtBubbleAriaLabel', 'other');
                break;
            }
            case 'screamBubble': {
                // text = 'Ropeboble';
                text = locales.getCaption('ScreamBubbleAriaLabel', 'other');
                break;
            }
            case 'complexSpeechBubble': {
                // text = 'Snakkeboble med flere haler';
                text = locales.getCaption('ComplexSpeechBubbleAriaLabel', 'other');
                break;
            }

            //buttons from the top area (Edit text): used for both tooltip and aria-label
            case 'fontColor': {
                if (!useTranslation)
                    text = 'Font color';
                else
                    text = locales.getCaption('fontColor', 'other');
                break;
            }
            case 'bold': {
                if (!useTranslation)
                    text = 'Bold';
                else
                    text = locales.getCaption('bold', 'other');
                break;
            }
            case 'italic': {
                if (!useTranslation)
                    text = 'Italic';
                else
                    text = locales.getCaption('italic', 'other');
                break;
            }
            case 'underline': {
                if (!useTranslation)
                    text = 'Underline';
                else
                    text = locales.getCaption('underline', 'other');
                break;
            }
            case 'leftAlign': {
                if (!useTranslation)
                    text = 'Left align';
                else
                    text = locales.getCaption('leftAlign', 'other');
                break;
            }
            case 'centerAlign': {
                if (!useTranslation)
                    text = 'Center align';
                else
                    text = locales.getCaption('centerAlign', 'other');
                break;
            }
            case 'rightAlign': {
                if (!useTranslation)
                    text = 'Right align';
                else
                    text = locales.getCaption('rightAlign', 'other');
                break;
            }
            case 'orderedList': {
                if (!useTranslation)
                    text = 'Ordered list';
                else
                    text = locales.getCaption('orderedList', 'other');
                break;
            }
            case 'bulletList': {
                if (!useTranslation)
                    text = 'Bullet list';
                else
                    text = locales.getCaption('bulletList', 'other');
                break;
            }
            case 'outdent': {
                if (!useTranslation)
                    text = 'Outdent';
                else
                    text = locales.getCaption('outdent', 'other');
                break;
            }
            case 'ident': {
                if (!useTranslation)
                    text = 'Ident';
                else
                    text = locales.getCaption('ident', 'other');
                break;
            }
            case 'superscript': {
                if (!useTranslation)
                    text = 'Superscript';
                else
                    text = locales.getCaption('superscript', 'other');
                break;
            }
            case 'subscript': {
                if (!useTranslation)
                    text = 'Subscript';
                else
                    text = locales.getCaption('subscript', 'other');
                break;
            }
            case 'lineHeight': {
                if (!useTranslation)
                    text = 'Line height';
                else
                  text = locales.getCaption('lineHeight', 'other');
                break;
            }

            // used for the title of the top area
            case 'editText': {
                if (!useTranslation)
                    text = 'Edit text';
                else
                    text = locales.getCaption('editText', 'other');
                break;
            }
            // used for the title of the bottom area
            case 'editTextElement': {
                if (!useTranslation)
                    text = 'Edit text element';
                else
                    text = locales.getCaption('editTextElement', 'other');
                break;
            }
            // used for insert image holder title
            case 'insertImageTitle': {
                text = locales.getCaption('insertImageTitle', 'other');
                break;
            }
            // used for insert image button
            case 'insertImage': {
                text = locales.getCaption('insertImage', 'other');
                break;
            }
            // used for replace image button
            case 'replaceImage': {
                text = locales.getCaption('replaceImage', 'other');
                break;
            }
            // used for remove image button
            case 'removeImage': {
                text = locales.getCaption('removeImage', 'other');
                break;
            }
            // the title on top of the Fonts Selector
            case 'fontTitle': {
                if (!useTranslation)
                    text = 'Font';
                else
                    text = locales.getCaption('fontTitle', 'other');
                break;
            }
            // the title on top of the Font Size Selector
            case 'sizeTitle': {
                if (!useTranslation)
                    text = 'Size';
                else
                    text = locales.getCaption('sizeTitle', 'other');
                break;
            }
            // aria label title used for the "PlusMoreColors" under Palete color
            case 'moreColors': {
                if (!useTranslation)
                    text = 'More colors';
                else
                    text = locales.getCaption('moreColors', 'other');
                break;
            }
            // the label title for the ColorPicker (input with type=color)
            case 'favoriteColor': {
                if (!useTranslation)
                    text = 'Select your favorite color';
                else
                    text = locales.getCaption('favoriteColor', 'other');
                break;
            }
            // the title and aria-label for FILL button
            case 'fillColor': {
                if (!useTranslation)
                    text = 'Fill';
                else
                    text = locales.getCaption('fillColor', 'other');
                break;
            }
            // the title and aria-label for BORDER button
            case 'borderColor': {
                if (!useTranslation)
                    text = 'Border color';
                else
                    text = locales.getCaption('borderColor', 'other');
                break;
            }
            // aria-label title for MINUS button
            case 'minus': {
                if (!useTranslation)
                    text = 'Decrease font size';
                else
                    text = locales.getCaption('minus', 'other');
                break;
            }
            // aria-label title for PLUS button
            case 'plus': {
                if (!useTranslation)
                    text = 'Increase font size';
                else
                    text = locales.getCaption('plus', 'other');
                break;
            }
        }

        return text;
    },
     show(target, type, position = 'top', useCurrentCaption = false, clientX = -1) {
        if (platformDetection.isIOS() || this.isRecording)
            return;

        this.removeOldTooltip();
        var text = this.getText(type);

        if (useCurrentCaption)
            text = type;

        if (text == '' || target == undefined)
            return;

        var padding = 8;
        var stemSize = 8;
        var extraOffset = 0;

        if (position == 'left' || position == 'right') {
            stemSize = 5;

            if (type == 'cancelVideo')
                extraOffset = 10;
        }

        this.toolTip = document.createElement('div');

        this.toolTip.style.position = 'absolute';
        this.toolTip.style.fontSize = '12px';
        this.toolTip.style.background = properties.RECORD_TOOLTIP_BACKGROUND;
        this.toolTip.style.wordWrap = 'break-word';
        this.toolTip.style.textAlign = 'center';
        this.toolTip.style.padding = padding + 'px';
        this.toolTip.style.borderRadius = '3px';
        this.toolTip.style.color = 'white';
        this.toolTip.style.display = 'block';
        this.toolTip.style.pointerEvents = 'none';
        this.toolTip.style.zIndex = 9999999;

        const bounds = target.getBoundingClientRect();
        const textWidth = textSizeUtils.getSpanWidth(12, text);
        var height = 14;
        var realWidth = textWidth + 2 * padding;
        var realHeight = height + 2 * padding;

        this.toolTip.innerHTML = text;
        this.toolTip.style.width = textWidth + 'px';
        this.toolTip.style.height = height + 'px';

        var stem = document.createElement('div');
        var stemWidth = 2 * stemSize;

        stem.style.position = 'absolute';
        stem.style.display = 'block';
        stem.style.borderStyle = 'solid';
        stem.style.borderWidth = stemSize + 'px';

        var offset = 2;

        switch(position) {
            case 'top': {
                stem.style.borderTopColor = properties.RECORD_TOOLTIP_BACKGROUND;
                stem.style.borderBottomColor = 'transparent';
                stem.style.borderLeftColor = 'transparent';
                stem.style.borderRightColor = 'transparent';

                var leftPositionValue;

                if (clientX > 0)
                    leftPositionValue  = clientX - realWidth / 2;
                else
                    leftPositionValue = bounds.left + bounds.width / 2 - realWidth / 2;

                if (leftPositionValue < 0)
                    leftPositionValue = 0;

                this.toolTip.style.left = leftPositionValue + 'px';
                this.toolTip.style.top = (bounds.top - realHeight - stemSize - offset) + 'px';

                stem.style.top = realHeight + 'px';
                stem.style.left = (realWidth / 2 - stemWidth / 2) + 'px';
                break;
            }
            case 'bottom': {
                stem.style.borderTopColor = 'transparent';
                stem.style.borderBottomColor = properties.RECORD_TOOLTIP_BACKGROUND;
                stem.style.borderLeftColor = 'transparent';
                stem.style.borderRightColor = 'transparent';

                this.toolTip.style.left = (bounds.left + bounds.width / 2 - realWidth / 2) + 'px';
                this.toolTip.style.top = (bounds.top + bounds.height + stemSize + offset) + 'px';

                stem.style.top = - 2 * stemSize + 'px';
                stem.style.left = (realWidth / 2 - stemWidth / 2) + 'px';
                break;
            }
            case 'left': {
                stem.style.borderTopColor = 'transparent';
                stem.style.borderBottomColor = 'transparent';
                stem.style.borderLeftColor = properties.RECORD_TOOLTIP_BACKGROUND;
                stem.style.borderRightColor = 'transparent';

                this.toolTip.style.left = (bounds.left - realWidth - stemSize - offset) + 'px';
                this.toolTip.style.top = (bounds.top + bounds.height / 2 - realHeight / 2 - extraOffset) + 'px';

                stem.style.top = (realHeight / 2 - stemSize) + 'px';
                stem.style.left = (realWidth) + 'px';
                break;
            }
            case 'right': {
                stem.style.borderTopColor = 'transparent';
                stem.style.borderBottomColor = 'transparent';
                stem.style.borderLeftColor = 'transparent';
                stem.style.borderRightColor = properties.RECORD_TOOLTIP_BACKGROUND;

                this.toolTip.style.left = (bounds.left + bounds.width + stemSize + offset) + 'px';
                this.toolTip.style.top = (bounds.top + bounds.height / 2 - realHeight / 2 - extraOffset) + 'px';

                stem.style.top = (realHeight / 2 - stemSize) + 'px';
                stem.style.left = (- 2 * stemSize) + 'px';
                break;
            }
        }

        this.toolTip.appendChild(stem);

        document.body.appendChild(this.toolTip);
    },
    hide() {
        if (platformDetection.isIOSApp())
            return;

        this.removeOldTooltip();
    },

    showHelpInfo(target, type) {
        this.removeOldTooltip();
        var text = this.getText(type);

        if (text == '' || target == undefined)
            return;

        var padding = 20;
        var stemSize = 10;
        var extraOffset = 0;
        var fontSize = 20;

        this.toolTip = document.createElement('div');

        this.toolTip.style.position = 'absolute';
        this.toolTip.style.fontSize = fontSize + 'px';
        this.toolTip.style.background = properties.RECORD_TOOLTIP_BACKGROUND;
        this.toolTip.style.wordWrap = 'break-word';
        this.toolTip.style.textAlign = 'center';
        this.toolTip.style.padding = padding + 'px';
        this.toolTip.style.borderRadius = '3px';
        this.toolTip.style.color = 'white';
        this.toolTip.style.display = 'block';
        this.toolTip.style.pointerEvents = 'none';

        const bounds = target.getBoundingClientRect();
        const textWidth = textSizeUtils.getSpanWidth(fontSize, text);
        var height = 24;
        var realWidth = textWidth + 2 * padding;
        var realHeight = height + 2 * padding;

        this.toolTip.innerHTML = text;
        this.toolTip.style.width = textWidth + 'px';
        this.toolTip.style.height = height + 'px';

        var stem = document.createElement('div');

        stem.style.position = 'absolute';
        stem.style.display = 'block';
        stem.style.borderStyle = 'solid';
        stem.style.borderWidth = stemSize + 'px';

        var offset = 5;

        stem.style.borderTopColor = 'transparent';
        stem.style.borderBottomColor = 'transparent';
        stem.style.borderLeftColor = properties.RECORD_TOOLTIP_BACKGROUND;
        stem.style.borderRightColor = 'transparent';

        this.toolTip.style.left = (bounds.left - realWidth - stemSize - offset) + 'px';
        this.toolTip.style.top = (bounds.top + bounds.height / 2 - realHeight / 2 - extraOffset) + 'px';

        stem.style.top = (realHeight / 2 - stemSize) + 'px';
        stem.style.left = (realWidth) + 'px';

        this.toolTip.appendChild(stem);

        document.body.appendChild(this.toolTip);
    }
};

export default hoverManager;



/** WEBPACK FOOTER **
 ** ./src/components/utils/HoverManager.js
 **/